module.exports = __webpack_public_path__ + "img/myAccount.9568f05d.png";